import { Tag } from 'antd';
import './style.scss'
import { UiDrawer, UiTextBox, UiSelect, UiButton } from '../../../../components';

const ConfigDrawer = ({
    open,
    onClose,
    formData,
    handleChange,
    handleChipChange,
    handleSave,
    isLoading,
    configTypeOptions,
    mode = 'add'
}) => {
    return (
        <UiDrawer
            title={mode === 'add' ? 'Create New Config' : 'Edit Config'}
            open={open}
            onClose={onClose}
            width={450}
        >
            <div className="add-config-container">
                <div className="content-wrapper">
                    <label style={{padding: "0px 10px"}}> Config ID <span>*</span></label>
                    <UiTextBox
                        required
                        placeholder="Eg: Config ID"
                        name="configId"
                        value={formData?.configId}
                        onChange={handleChange}
                        disabled={mode === 'add' ? false : true}
                    />
                    <div className="config-value-label">
                        <label>
                            Config Value <span>*</span>
                        </label>
                    </div>
                    <div className="config-value-input-wrapper">
                        <div className="config-input-box">
                            <div>
                                <div id="chip-row" className={formData?.configValue?.length > 0 ? '' : 'hidden'}>
                                    {formData?.configValue?.map((value, index) => (
                                        <Tag
                                            key={index}
                                            closable
                                            onClose={() => handleChipChange(null, true, value)}
                                            className={value === formData?.defaultValue ? 'default-tag' : ''}
                                            style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}
                                        >
                                            {value}
                                        </Tag>
                                    ))}
                                </div>
                                <UiTextBox
                                    type="text"
                                    placeholder="Enter Config Value"
                                    value={formData?.configValueInput}
                                    onChange={(event) => {
                                        event.target.name = 'configValueInput';
                                        handleChipChange(event);
                                    }}
                                    onKeyDown={(event) => {
                                        event.target.name = 'configValueInput';
                                        handleChipChange(event);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div style={{padding : '0px 10px' , marginTop:'8px'}} >
                    <label>
                        Default Value <span>*</span>
                    </label>
                    </div>
                    <UiTextBox
                        required
                        placeholder="Select Value"
                        name="defaultValue"
                        value={formData?.defaultValue}
                        onChange={handleChange}
                    />
                    <div className="config-type-wrapper">
                        <label>
                            Config Type <span>*</span>
                        </label>
                        <UiSelect
                            required
                            placeholder="Select"
                            options={configTypeOptions}
                            onChange={(selectedKey, gst, selectedValue, selectedOption) => {
                                handleChange(selectedValue || selectedKey, 'configType', true);
                            }}
                            value={formData?.configType}
                            className="ui-select-wrapper"
                        />
                    </div>
                </div>
                <div className="button-wrapper">
                    <UiButton onClick={onClose} className="cancel-btn" disabled={isLoading}>Cancel</UiButton>
                    <UiButton type="primary" onClick={handleSave} className="save-btn" loading={isLoading} disabled={!(formData?.configId?.trim() && formData?.configValue?.length > 0 && formData?.defaultValue?.trim() && formData?.configType) || isLoading}>
                        {mode === 'add' ? 'Save' : 'Update'}
                    </UiButton>
                </div>
            </div>
        </UiDrawer>
    );
};

export default ConfigDrawer;
